const NotFound = () => {
  return (
    <div className="flex size-full items-center justify-center">
      <p>Page Not Found</p>
    </div>
  );
};

export default NotFound;
